// Wrapper de localStorage a prueba de navegadores que bloquean todo el
// storage del sitio: en ese modo, acceder a localStorage no devuelve null,
// tira un SecurityError síncrono — sin este wrapper, cualquier useState
// inicializado desde localStorage (ej. tema, flags de layout) crashea el
// render inicial de toda la app antes de llegar siquiera a la pantalla de
// login.
export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Storage bloqueado: la app sigue funcionando sin persistencia.
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignorar
    }
  },
};
